import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from 'antd';
import clsx from 'clsx';
import debounce from 'lodash.debounce';
import routes from 'src/routes';
import { AlertTable } from './AlertTable';
import { SegmentInfo } from './SegmentInfo';
import { OperationType } from '../types/SelectedOperation';
import { ProductAlertsContext } from '../ProductAlertsProvider';
import { SelectedOperationActions } from './SelectedOperationActions';
import styles from './AlertManagement.module.less';

type PropsParams = {
  segmentId: string;
  isCreateAlert: string;
};

const ButtonGroup = Button.Group;
const { Search } = Input;

export const AlertManagement = () => {
  const { setSelectedOperation } = useContext(ProductAlertsContext);
  const params = useParams<PropsParams>();
  const [associated, setAssociated] = useState<boolean>(true);
  const [alertName, setAlertName] = useState<string>('');
  const [tableReloadKey, setTableReloadKey] = useState<number>(1);

  const handleCreate = () => {
    setSelectedOperation({ type: OperationType.CreateAlert, segmentId: +params.segmentId });
  };

  const handleSearchAlert = (value: string): void => {
    setAlertName(value);
  };

  const handleDebounce = debounce((value: string) => {
    setAlertName(value);
  }, 1000);

  const handleChangeAlert = (event: React.ChangeEvent<HTMLInputElement>): void => {
    handleDebounce(event.target.value);
  };

  useEffect(() => {
    if (params.isCreateAlert === 'new') {
      handleCreate();
    }
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.rootHeader}>
        <Link className={styles.btnBack} to={routes.productAlerts + '/segmentConfig'}>
          <FontAwesomeIcon icon={['far', 'chevron-left']} className={styles.textBack} />
          <p className={styles.textBack}>Back to Segment Config</p>
        </Link>

        <h1 className={styles.title}>Alert Management</h1>
      </div>
      <SegmentInfo segmentId={params.segmentId} />

      <div className={styles.content}>
        <div className={styles.header}>
          <Button type="primary" onClick={handleCreate} className={styles.btnAddAlert}>
            <FontAwesomeIcon icon={['fal', 'plus']} size="lg" className={styles.iconPlus} /> Create New Alert
          </Button>
          <Search
            className={styles.header__search}
            placeholder="Add more keywords to refine your results"
            onSearch={handleSearchAlert}
            onChange={handleChangeAlert}
            allowClear
          />
          <ButtonGroup className={styles.groupBtnTab}>
            <Button
              className={clsx(styles.btnTab, associated && styles.activeBtnTab)}
              onClick={() => setAssociated(true)}
            >
              Associated Alerts
            </Button>
            <Button
              className={clsx(styles.btnTab, !associated && styles.activeBtnTab)}
              onClick={() => setAssociated(false)}
            >
              Unassociated Alerts
            </Button>
          </ButtonGroup>
        </div>
        <AlertTable key={tableReloadKey} associated={associated} segmentId={params.segmentId} alertName={alertName} />
      </div>

      <SelectedOperationActions onAlertUpdate={() => setTableReloadKey((prev) => prev + 1)} />
    </div>
  );
};
